import { GetPageByRouteQuery } from "@eurodrive/apollo"
import { getPathname } from "next-impl-getters/get-pathname"
import { extractProperty } from "./extractProperty"
import { getUmbracoMediaUrl } from "./getUmbracoMediaUrl"

export type MetaData = {
  pageSlug: string | undefined
  metaTitle: string | undefined
  metaKeywords: string | undefined
  metaDescription: string | undefined
  robotsTxt: string | undefined
  canonicalUrl: string | undefined
  oldUrls: string[]
  jsonPdSchema: string | undefined
}
export type Category = {
  metaData: MetaData
}

function getServerCanonicalUrl() {
  const pathname = getPathname()
  const noLocalePathname = pathname?.replace(/^\/(en-us|he-il|en|he)\//, "/")
  return noLocalePathname || "/"
}

export function getMataTag(object: any) {
  return {
    pageSlug: extractProperty(object, "pageslug") as string | undefined,
    metaTitle: extractProperty(object, "metaTitle") as string | undefined,
    metaKeywords: extractProperty(object, "metaKeywords") as string | undefined,
    metaDescription: extractProperty(object, "metaDescription") as
      | string
      | undefined,
    robotsTxt:
      process.env.BLOCK_INDEXING === "true" || process.env.ENV !== "production"
        ? {
            index: false,
            follow: false,
          }
        : (extractProperty(object, "robotsTxt") as string | undefined) ||
          undefined,
    canonicalUrl:
      (extractProperty(object, "canonicalUrl") as string) ||
      getServerCanonicalUrl(),
    oldUrls: extractProperty(object, "oldUrls") as string[],
    titleBreadcrumbs: extractProperty(object, "titleBreadcrumbs") as
      | string
      | undefined,
    ogImage: getUmbracoMediaUrl(
      extractProperty(object, "ogImageSHARE") as string | undefined,
    ),
    jsonPdSchema: extractProperty(object, "jsonPdSchema") as string | undefined,
  }
}

type Props = {
  itemsData: GetPageByRouteQuery
  infoBlock?: boolean
}
export function extractMetaTags({ itemsData }: Props) {
  let object = itemsData.page
  const pageBlock = extractProperty(object, "pageInfoAndMetaTags")
  const pageInfo = extractProperty(object, "pageInfoBlockContent")
  if (pageBlock) {
    object = pageBlock?.[0]
  } else if (pageInfo) {
    object = pageInfo?.[0]
  }
  const metaData = getMataTag(object)
  return metaData
}
